export default __webpack_public_path__ + "static/media/SFUIText-Medium.80fd80db.woff";